import { PremiumBackground } from '../effects/PremiumBackground';
import React, { useState } from 'react';
import { 
Briefcase, 
  Scale, 
  BarChart3, 
  ShieldCheck, 
  Target, 
  Cpu, 
  ArrowDown, 
  CheckCircle2, 
  Gavel,
  Award,
  Sparkles,
  ChevronRight,
  Shield,
  Layers,
  ArrowUpRight
} from 'lucide-react';

export interface MASyndicateProps {
  id?: string;
}

export const MASyndicate: React.FC<MASyndicateProps> = ({ id = 'syndicate' }) => {
  const [activePractice, setActivePractice] = useState<string | null>(null);

  const practices = [
    {
      id: '01',
      tag: 'FINANCIAL FORENSICS',
      name: '1. Практика финансовых расследований и корпоративных финансов',
      roleSubtitle: 'Senior Medical CFO',
      icon: BarChart3,
      badgeText: 'text-[#1E2B45]',
      whoWorks: 'Экс-аудиторы международных аудиторских компаний (Big-4) и финансовые директора медицинских сетей.',
      zoneOfResponsibility:
        'Построение доказательного моста нормализации прибыли (Quality of Earnings Bridge), легальный возврат личных расходов фаундера в расчет прибыли (Add-backs), защита оборотного капитала (NWC Peg), аудит незавершенного производства по длинным планам лечения (WIP) и расчет себестоимости кресло-часа.',
      keyArtifacts: ['QoE Bridge', 'Add-backs', 'NWC Peg', 'WIP']
    },
    {
      id: '02',
      tag: 'TAX LITIGATION',
      name: '2. Практика налогового арбитража и защиты от ст. 54.1 НК РФ',
      roleSubtitle: 'Налоговые адвокаты',
      icon: Gavel,
      badgeText: 'text-[#5E1B30]',
      whoWorks: 'Адвокаты по сложным налоговым спорам с опытом ведения дел в Арбитражных судах РФ.',
      zoneOfResponsibility:
        'Аудит исторического дробления бизнеса, реализация безналоговой консолидации активов по правилам Амнистии (ФЗ № 176-ФЗ), устранение рисков по врачам-самозанятым, защита нулевой ставки по налогу на прибыль (ст. 284.1 НК РФ) и выстраивание налогового контура 2026 года.',
      keyArtifacts: ['Амнистия 176-ФЗ', 'Ст. 54.1 НК РФ', 'Ставка 0% ст. 284.1', 'Контур 2026']
    },
    {
      id: '03',
      tag: 'TRANSACTIONAL LEGAL',
      name: '3. Практика транзакционного M&A-права и корпоративных структур',
      roleSubtitle: 'M&A Legal Lead',
      icon: Scale,
      badgeText: 'text-[#8C6D37]',
      whoWorks: 'Корпоративные юристы, специализирующиеся исключительно на сделках слияний и поглощений.',
      zoneOfResponsibility:
        'Проектирование обязывающих договоров купли-продажи долей (SPA), нейтрализация пунктов о расторжении аренды при смене владельцев (Change of Control), конструирование условий безакцептного возмещения потерь (ст. 406.1 ГК РФ) и лимитирование заморозки средств продавца на эскроу-счетах (Tax Escrow).',
      keyArtifacts: ['Договор SPA', 'Change of Control', 'Ст. 406.1 ГК РФ', 'Tax Escrow']
    },
    {
      id: '04',
      tag: 'MEDICAL COMPLIANCE',
      name: '4. Практика медицинского права, лицензирования и СанПиН',
      roleSubtitle: 'Экс-инспекторы надзорных органов',
      icon: ShieldCheck,
      badgeText: 'text-[#59534B]',
      whoWorks: 'Специалисты в области медико-биологического права, экс-сотрудники органов лицензионного контроля.',
      zoneOfResponsibility:
        'Сплошной аудит соответствия фактических услуг лицензионному досье Росздравнадзора, проверка радиационной безопасности томографов и рентген-кабинетов (ИИИ), натурная сверка планировок БТИ с нормами СанПиН, проверка обращения с медицинскими отходами классов Б и Г через ГИС ОПВК.',
      keyArtifacts: ['Лицензии РЗН', 'ИИИ и Рентген', 'Планы БТИ / СанПиН', 'ГИС ОПВК']
    },
    {
      id: '05',
      tag: 'MARKETING FORENSICS',
      name: '5. Практика маркетингового форензика и юнит-экономики',
      roleSubtitle: 'Marketing Forensics Team',
      icon: Target,
      badgeText: 'text-[#1E2B45]',
      whoWorks: 'Аналитики данных МИС и аудиторы коммерческого трафика.',
      zoneOfResponsibility:
        'Доказательство «твердости» выручки клиники, независимая проверка сквозной воронки привлечения пациентов (LTV/CAC), выявление накруток показателей доходимости, аудит работы регистратуры методом «Тайного покупателя» и оцифровка упущенной выгоды для инвестора.',
      keyArtifacts: ['Твердость выручки', 'LTV / CAC воронка', 'Тайный покупатель', 'Оцифровка МИС']
    },
    {
      id: '06',
      tag: 'TECHNICAL & IT FORENSICS',
      name: '6. Практика инженерно-технического и цифрового аудита',
      roleSubtitle: 'Technical & IT Engineers',
      icon: Cpu,
      badgeText: 'text-[#8C6D37]',
      whoWorks: 'Инженеры медицинской техники и сертифицированные аудиторы информационной безопасности (ФСТЭК).',
      zoneOfResponsibility:
        'Сверка серийных номеров томографов и установок с реестром Регистрационных Удостоверений (РУ), проверка лицензий сервисных организаций по Постановлению № 2129, аудит локализации серверов медицинских баз данных по 152-ФЗ и проверка выгрузок в ЕГИСЗ (РЭМД).',
      keyArtifacts: ['Реестр РУ', 'ПП РФ № 2129', '152-ФЗ локализация', 'ЕГИСЗ / РЭМД']
    },
  ];

  return (
    <section
      id={id}
      aria-label="Синдикат M&A-экспертизы: 7 практик защиты"
      className="relative w-full bg-[#E2E8F0] text-[#141416] py-24 md:py-32 border-t border-[#CBD5E1] font-sans overflow-hidden"
    >
      {/* ТАКТИЛЬНЫЙ МАКРО-РЕЛЬЕФ */}
      <PremiumBackground variant={1} />

      
      

      {/* Light subtle archival paper gradient */}
      <div className="absolute top-0 left-0 right-0 h-48 bg-gradient-to-b from-[#F2EDE4]/60 to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        
        {/* =========================================================================
            1. НАДЗАГОЛОВОК, 2. ЗАГОЛОВОК H2, 3. ПОДЗАГОЛОВОК-МАНИФЕСТ
            ========================================================================= */}
        <div className="max-w-4xl mb-16 flex flex-col gap-6">
          <div className="luxury-eyebrow text-[#8C6D37] flex items-center gap-2.5 font-bold tracking-[0.2em] uppercase">
            <span className="w-1.5 h-1.5 rounded-none bg-[#8C6D37]" />
            ЭТАЖ 12 // ИНСТИТУЦИОНАЛЬНЫЙ СИНДИКАТ // M&A-ЭКСПЕРТИЗА
          </div>

          <h2 className="text-3xl sm:text-5xl lg:text-[54px] font-serif font-semibold tracking-tight leading-[1.1] text-[#141416]">
            Синдикат M&A-экспертизы: <br />
            <span className="text-[#64748B] italic font-serif">
              междисциплинарный штаб защиты капитала
            </span>
          </h2>

          <div className="text-[16px] sm:text-[17px] text-[#334155] leading-[1.65] font-sans font-normal space-y-3 max-w-3xl border-l-[4px] border-[#8C6D37] pl-6 mt-4">
            <p>
              Институциональная сделка в медицине невозможна силами одного корпоративного юриста или штатного главного бухгалтера.
            </p>
            <p>
              Против вас работает армия финансовых аналитиков, налоговых консультантов и технических экспертов покупателя.
            </p>
            <p className="text-[#141416] font-bold">
              Structure & Partners выставляет равный по силе встречный щит из 7 специализированных практик.
            </p>
          </div>
        </div>

        {/* =========================================================================
            4. АРХИТЕКТУРА СИНДИКАТА: ФЛАГМАНСКАЯ КАРТОЧКА (УПРАВЛЯЮЩИЙ ПАРТНЕР)
            ========================================================================= */}
        <div className="relative mb-14">
          <div className="rounded-[2px] border border-[#8C6D37]/40 bg-white p-8 sm:p-10 md:p-12 shadow-xs relative overflow-hidden group">
            {/* Top gold accent bar */}
            <div className="absolute top-0 left-0 w-full h-1 bg-[#8C6D37]" />

            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8 pb-8 border-b border-[#CBD5E1] relative z-10">
              <div className="flex items-start sm:items-center gap-5">
                <div className="w-16 h-16 rounded-[2px] bg-[#FFFFFF] text-[#8C6D37] flex items-center justify-center shrink-0 border border-[#8C6D37]/40 relative group-hover:scale-105 transition-transform duration-500 shadow-xs">
                  <Briefcase className="w-7 h-7 text-[#8C6D37]" />
                  <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-none bg-[#8C6D37] ring-2 ring-white" />
                </div>
                <div>
                  <div className="flex flex-wrap items-center gap-2.5 mb-2">
                    <span className="font-mono text-[10px] text-[#64748B] font-bold uppercase tracking-[0.15em] bg-[#FFFFFF] px-2.5 py-1 rounded-[2px] border border-[#CBD5E1]">
                      DEAL ARCHITECT // УПРАВЛЯЮЩИЙ ПАРТНЕР
                    </span>
                    <span className="font-mono text-[10px] text-[#8C6D37] font-bold uppercase tracking-wider bg-[#8C6D37]/10 px-2 py-1 rounded-[2px] border border-[#8C6D37]/40">
                      LEAD NEGOTIATOR
                    </span>
                  </div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-semibold text-[#141416] tracking-tight">
                    Алексей Киселев
                  </h3>
                </div>
              </div>

              {/* Метрика и статус */}
              <div className="flex items-center gap-6 font-mono text-xs text-[#334155] bg-[#FFFFFF] px-6 py-4 rounded-[2px] border border-[#CBD5E1] shadow-xs">
                <div>
                  <span className="text-[10px] text-[#64748B] uppercase tracking-wider block mb-0.5 font-bold">Уровень мандата:</span>
                  <span className="font-bold text-[#141416] text-[13px]">Первые лица фондов / СЕО</span>
                </div>
                <div className="h-8 w-px bg-[#CBD5E1]" />
                <div>
                  <span className="text-[10px] text-[#64748B] uppercase tracking-wider block mb-0.5 font-bold">Таргет оценки:</span>
                  <span className="font-bold text-[#8C6D37] text-[13px]">До 7.5x EBITDA</span>
                </div>
              </div>
            </div>

            {/* Функционал в сделке */}
            <div className="pt-7 relative z-10">
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#141416] font-bold block mb-3 flex items-center gap-2">
                <Award className="w-4 h-4 text-[#8C6D37]" />
                Функционал в сделке:
              </span>
              <p className="text-[15px] sm:text-[16px] text-[#334155] leading-[1.75] font-normal max-w-5xl">
                Личное ведение стратегических переговоров с первыми лицами инвестиционных фондов, страховых групп и федеральных медицинских сетей. 
                Формирование архитектуры транзакции, проектирование закрытого конкурса покупателей (Bidding Process), 
                защита оценки бизнеса от психологического прессинга и удержание целевого мультипликатора (до 7.5x EBITDA).
              </p>
            </div>
          </div>
        </div>

        {/* =========================================================================
            СЕТКА ИЗ 6 СПЕЦИАЛИЗИРОВАННЫХ ПРАКТИК (Desktop: 3x2; Mobile: Stack)
            ========================================================================= */}
        <div className="mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {practices.map((practice) => {
              const IconComp = practice.icon;
              const isSelected = activePractice === practice.id;

              return (
                <div
                  key={practice.id}
                  onClick={() => setActivePractice(isSelected ? null : practice.id)}
                  className={`group relative rounded-[2px] p-7 sm:p-8 flex flex-col justify-between transition-all duration-300 border cursor-pointer overflow-hidden ${
                    isSelected 
                      ? 'border-[#8C6D37] bg-white shadow-sm ring-1 ring-[#8C6D37]'
                      : 'border-[#CBD5E1] hover:border-[#CBD5E1] bg-white shadow-xs'
                  }`}
                >
                  <div className="relative z-10">
                    {/* Header */}
                    <div className="flex items-start justify-between gap-3 mb-6 pb-4 border-b border-[#CBD5E1]">
                      <div className="flex items-center gap-3.5">
                        <div className={`w-10 h-10 rounded-[2px] flex items-center justify-center transition-all duration-300 ${
                          isSelected 
                            ? 'bg-[#8C6D37] text-white border border-[#8C6D37]' 
                            : 'bg-[#FFFFFF] border border-[#CBD5E1] text-[#64748B] group-hover:border-[#8C6D37]/40 group-hover:text-[#8C6D37]'
                        }`}>
                          <IconComp className="w-5 h-5" />
                        </div>
                        <div>
                          <span className={`font-mono text-[9px] font-bold uppercase tracking-[0.15em] block mb-0.5 text-[#8C6D37]`}>
                            {practice.tag}
                          </span>
                          <span className="text-[13px] font-bold text-[#141416]">
                            {practice.roleSubtitle}
                          </span>
                        </div>
                      </div>
                      <span className="font-mono text-[11px] text-[#8C6D37] font-bold bg-[#8C6D37]/10 px-2 py-0.5 rounded-[2px] border border-[#8C6D37]/30">
                        {practice.id}
                      </span>
                    </div>

                    {/* Title */}
                    <h4 className="text-[16px] sm:text-[17px] font-serif font-semibold text-[#141416] leading-snug mb-5 group-hover:text-[#8C6D37] transition-colors">
                      {practice.name}
                    </h4>

                    {/* Content: Кто работает */}
                    <div className="mb-4">
                      <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#141416] font-bold block mb-1">
                        Кто работает:
                      </span>
                      <p className="text-[13px] text-[#334155] leading-relaxed font-normal">
                        {practice.whoWorks}
                      </p>
                    </div>

                    {/* Content: Зона ответственности */}
                    <div className="space-y-1 mb-6">
                      <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#8C6D37] font-bold block mb-1">
                        Зона ответственности:
                      </span>
                      <p className="text-[13px] text-[#64748B] leading-relaxed font-normal">
                        {practice.zoneOfResponsibility}
                      </p>
                    </div>
                  </div>

                  {/* Ключевые артефакты / системные теги */}
                  <div className="pt-4 border-t border-[#CBD5E1] relative z-10">
                    <div className="flex flex-wrap gap-1.5">
                      {practice.keyArtifacts.map((art, idx) => (
                        <span
                          key={idx}
                          className={`font-mono text-[10px] px-2.5 py-0.5 rounded-[2px] border transition-colors ${
                            isSelected 
                              ? 'bg-[#8C6D37]/15 border-[#8C6D37]/40 text-[#8C6D37] font-bold' 
                              : 'bg-[#FFFFFF] border-[#CBD5E1] text-[#64748B] group-hover:border-[#8C6D37]/30'
                          }`}
                        >
                          {art}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* =========================================================================
            5. ПРИНЦИП ИНСТИТУЦИОНАЛЬНОГО ПАРИТЕТА (CALLOUT BOX)
            ========================================================================= */}
        <div className="rounded-[2px] border-l-4 border-l-[#8C6D37] border-y border-r border-[#8C6D37]/40 p-8 sm:p-10 mb-16 shadow-xs bg-[#8C6D37]/10 relative overflow-hidden">
          <div className="flex items-start gap-5 relative z-10">
            <div className="w-12 h-12 rounded-[2px] bg-white border border-[#8C6D37]/40 flex items-center justify-center text-[#8C6D37] shrink-0 mt-0.5 shadow-xs">
              <Scale className="w-6 h-6" />
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <span className="font-mono text-[10px] uppercase font-bold text-[#8C6D37] tracking-[0.2em] bg-[#8C6D37]/20 px-2.5 py-0.5 rounded-[2px] border border-[#8C6D37]/40">
                  INSTITUTIONAL PARITY
                </span>
                <span className="font-mono text-[10px] uppercase font-bold text-[#64748B] tracking-wider">
                  M&A COUNTERWEIGHT
                </span>
              </div>
              <h4 className="text-lg sm:text-xl font-serif font-semibold text-[#141416] tracking-tight">
                Почему побеждает Синдикат Structure & Partners
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#334155] leading-relaxed font-normal">
                Инвестиционный комитет покупателя всегда выставляет против продавца узкопрофильных специалистов: 
                финансист ищет дыры в балансе, юрист — пороки аренды, а врач-эксперт — дефекты карт.
              </p>
              <p className="text-[15px] sm:text-[16px] text-[#141416] font-bold leading-relaxed bg-white p-4 rounded-[2px] border-l-2 border-[#8C6D37] shadow-xs">
                Мы закрываем каждую брешь профильным экспертом встречного уровня. За счет этого ни один аргумент покупателя о снижении цены не остается без доказательного отпора.
              </p>
            </div>
          </div>
        </div>

        {/* =========================================================================
            НАВИГАТОР ПЕРЕХОДА К СЛЕДУЮЩЕМУ БЛОКУ (ЭТАЖ 13: РЕЕСТР ПРЕЦЕДЕНТОВ)
            ========================================================================= */}
        <div className="text-center pt-2">
          <a
            href="#precedents"
            className="group inline-flex items-center gap-2 font-mono text-[11px] text-[#64748B] hover:text-[#141416] uppercase tracking-[0.15em] font-bold transition-all py-3 px-6 hover:bg-black/5 border border-transparent hover:border-[#CBD5E1] rounded-[2px]"
          >
            <span>[ ПЕРЕЙТИ К ЭТАЖУ 13: РЕЕСТР ПРЕЦЕДЕНТОВ & ТОМБСТОУНЫ ↓ ]</span>
          </a>
        </div>

      </div>
    </section>
  );
};
